import {
  RegionOfInterestAnnotation,
  XYPoint,
  ScaleInfo,
} from "custom-models/ViewerTypes";

import { AnnotationColors } from "./subtree";
import ViewerFacade from "../ViewerFacade";

interface RegionOfInterestProps {
  annotation: RegionOfInterestAnnotation;
  scaleInfo: ScaleInfo;
  viewerFacade: ViewerFacade;
  isVisible: boolean;
  isSelected?: boolean;
  closed?: boolean;
}

function pathInfo(points: Array<XYPoint>, closed = true) {
  if (points && points.length > 2) {
    return (closed ? points.concat([points[0]]) : points).reduce(
      (acc, e, i) => {
        return acc + (i === 0 ? "M" : " L") + e.x + "," + e.y;
      },
      ""
    );
  }
  if (points.length === 2) {
    return `M${points[0].x},${points[0].y} L${points[1].x},${points[1].y}`;
  }
  return "";
}

const RegionOfInterest = (props: RegionOfInterestProps) => {
  const { annotation, scaleInfo } = props;
  const { points, is_diagnostic } = annotation;
  const { isVisible, isSelected, closed } = props;
  const color = isSelected
    ? AnnotationColors.SELECTED
    : props.annotation.id
    ? is_diagnostic
      ? AnnotationColors.DIAGNOSTIC
      : AnnotationColors.DEFAULT
    : AnnotationColors.ACTIVE;
  return (
    <g className="WSI-ROI">
      {points.map((point, index: number) => (
        <circle
          key={`${point.x},${point.y},${index}`}
          r={5.0 / scaleInfo.scaleX}
          cx={point.x}
          cy={point.y}
          opacity={isVisible ? 0.8 : 0.1}
          fill={color}
        />
      ))}
      <path
        fill="none"
        d={pathInfo(points, closed)}
        stroke={color}
        strokeWidth={3 / scaleInfo.scaleX}
        opacity={isVisible ? 0.8 : 0.1}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  );
};

export default RegionOfInterest;
